import UserService from "../../Services/Api/UserService";
import Vue from 'vue';

export const state = {
    subscriptionQuota: {}
}

export const mutations = {
    SET_SUBSCRIPTION_QUOTA(state, data) {
        state.subscriptionQuota = data
    },
}

export const getters = {
    subscriptionQuota(state) {
        return state.subscriptionQuota
    },
}

export const actions = {
    async getSubscriptionQuota({commit}) {
        // if user has subscription
        if (Vue.auth.priv('has-subscription')) {
            const {data: data} = await UserService.getUserSubscriptionQuota()
            commit('SET_SUBSCRIPTION_QUOTA', data.data)
        }
    }
}

